import React, { useState } from 'react';

import classNames from 'classnames';

interface Props {
	className?: string;
	imageURL: string;
	altText?: string;
	title: React.ReactNode;
	description: React.ReactNode;
	price: React.ReactNode;
	priceSuffix: React.ReactNode;
	linkURL: string;
	linkText: React.ReactNode;
}

export default function BookingPromoCard({
	className,
	imageURL,
	altText,
	title,
	description,
	price,
	priceSuffix,
	linkURL,
	linkText,
}: Props) {
	const [imageError, setImageError] = useState(false);
	const showImage = !!imageURL && !imageError;

	return (
		<a
			className={classNames('booking-promo-card', { 'no-image': !showImage }, className)}
			href={prefixWithHttp(linkURL)}
			target="_blank"
			rel="noopener noreferrer"
		>
			<div className="card-layout">
				{showImage && (
					<div className="image-section">
						<img src={imageURL} alt={altText} onError={() => setImageError(true)} />
					</div>
				)}
				<div className="content-section">
					<div className="content-top">
						<h4 className="title">{title}</h4>
						<p className="description">{description}</p>
					</div>
					<div className="content-bottom">
						<div className="price-container">
							<span className="price">{price}</span>
							<span className="suffix">{priceSuffix}</span>
						</div>
						<span className="book-now-btn">{linkText}</span>
					</div>
				</div>
			</div>
		</a>
	);
}

const prefixWithHttp = (url: string) => {
	if (url.includes('://')) {
		return url;
	}
	return `https://${url}`;
};
